var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewestfilters = function SvgNewestfilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.263 12.946 2.472-2.471-.943-.943-.862.862v-6.39h-1.333v6.39l-.862-.862-.943.943zM5.471 4 3 6.471l.943.943.862-.862v6.39h1.333v-6.39L7 7.414l.943-.943z"
  })));
};
export default SvgNewestfilters;